module.exports = __webpack_public_path__ + "img/view result.a6ccc52f.svg";